module.exports = __webpack_public_path__ + "img/face.65a9ce27.png";